<template>
    <div :class="showTopTit ? 'pdTop' : ''">
        <div class="topTit" id="topTit" ref="topTit" v-if="showTopTit">
            <van-icon @click.stop="goBack" name="arrow-left" color="#515151" size="0.28rem" />
            <van-notice-bar class="navText" color="#333" background="#fff" v-if="topTitle">{{topTitle}}</van-notice-bar>
            <div class="refresh" @click.stop="refreshClick">
                <img src="~assets/images/recmmendImg/refresh.png" />
            </div>
        </div>
        <div class="justBox head">
            <img class="bg" :src="tBgImage" alt="">
            <div class="btn" @click="clickBtn(1)">
                <div class="btnTxt"><img v-if="status == 1 || status == 3" class="downloadIcon" src="~assets/justGunfight/downloadIcon.png" alt="">{{btnTxt ? btnTxt : "开始下载"}}</div>
                <div class="progress" :style="{width: progressWidth}"></div>
            </div>
        </div>
        <div class="justBox oneMain">
            <img class="bg" src="~assets/justGunfight/one.jpg" alt="">
            <div class="btn" @click="clickBtn(2)">
                <div class="btnTxt">{{btnTxt ? btnTxt : "注册领取"}}</div>
                <img src="~assets/justGunfight/btnBg1.png" alt="">
            </div>
        </div>
        <div class="justBox twoMain">
            <img class="bg" src="~assets/justGunfight/two.jpg" alt="">
            <div class="btn" @click="clickBtn(3)">
                <div class="btnTxt">{{btnTxt ? btnTxt : "登录观看"}}</div>
                <img src="~assets/justGunfight/btnBg1.png" alt="">
            </div>
        </div>
        <div class="justBox threeMain">
            <img class="bg" src="~assets/justGunfight/three.jpg" alt="">
            <div class="btn" @click="clickBtn(4)">
                <div class="btnTxt">{{btnTxt ? btnTxt : "登录观看"}}</div>
                <img src="~assets/justGunfight/btnBg1.png" alt="">
            </div>
        </div>
        <div class="justBox fourMain">
            <img class="bg" src="~assets/justGunfight/four.jpg" alt="">
            <div class="btn" @click="clickBtn(5)">
                <div class="btnTxt">{{btnTxt ? btnTxt : "前往领取"}}</div>
                <img src="~assets/justGunfight/btnBg1.png" alt="">
            </div>
        </div>
        <div class="justBox fiveMain">
            <img class="bg" src="~assets/justGunfight/five.jpg" alt="">
            <div class="btn" @click="clickBtn(6)">
                <div class="btnTxt">{{btnTxt ? btnTxt : "登录领取"}}</div>
                <img src="~assets/justGunfight/btnBg1.png" alt="">
            </div>
        </div>
        <div class="justBox sixMain">
            <img class="bg" src="~assets/justGunfight/six.jpg" alt="">
            <div class="shareBtn">
                <template v-for="item in shareData.btnArr">
                    <div class="iconItem" :key="item" v-if="item == 1" @click.stop="shareWeb(0x1)">
                        <img src="~assets/images/recmmendImg/wechatShare.png" alt="">
                        <p>微信</p>
                    </div>
                    <div class="iconItem" :key="item" v-if="item == 2" @click.stop="shareWeb(0x2)">
                        <img src="~assets/images/recmmendImg/wechatMoments.png" alt="">
                        <p>朋友圈</p>
                    </div>
                    <div class="iconItem" :key="item" v-if="item == 3" @click.stop="shareWeb(0x3)">
                        <img src="~assets/images/recmmendImg/qq.png" alt="">
                        <p>QQ</p>
                    </div>
                    <div class="iconItem" :key="item" v-if="item == 4" @click.stop="shareWeb(0x4)">
                        <img src="~assets/images/recmmendImg/qqZone.png" alt="">
                        <p>QQ空间</p>
                    </div>
                </template>
            </div>
        </div>
        <div class="mask" v-show="showMask">
            <div
            class="maskBox"
            :class="maskType === 1 ? 'tapeBox' : maskType === 8 || maskType === 9 ? 'padbottom' : ''"
            >
                <div class="closeMask" @click.stop="closeIconMask">
                    <img src="~assets/images/recmmendImg/close.png" alt />
                </div>
                <div class="toastMask" v-if="maskType === 3">
                    <div class="tit">{{txtTitle}}</div>
                    <p>{{txtContent}}</p>
                    <div class="toastBtn" @click.stop="closeMask">{{txtBtn}}</div>
                </div>
                <div class="phoneMain" v-if="maskType === 9">
                    <div class="phonBox terminalTips">
                    <div class="tit">下载233乐园 赢取好礼</div>
                    <p>参加活动，赢取游戏好礼，233乐园【活动专区】更多游戏礼物等你来领取</p>
                    </div>
                    <van-button
                    class="phoneBtn"
                    plain
                    color="#FF9500"
                    type="primary"
                    @click.stop="joinTerminal"
                    >下载参加活动</van-button>
                </div>
            </div>
        </div>
        <div class="maskLoading" v-show="maskLoadingflag">
            <img src="~assets/images/load.svg" alt />
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import { mapState } from "vuex";
import config from "@/../config";
import active from '@/utils/axios/index'
import primaryApi from '@/utils/primaryApi'
import qs from 'qs'
import { Toast, Button, Icon, NoticeBar } from 'vant';
Vue.use(Toast);
Vue.use(Button);
Vue.use(Icon);
Vue.use(NoticeBar);
export default {
    inject: ["reload"],
    data() {
        return {
            entryObj: {}, // 模块配置基本信息
            topTitle: "", //头部标题
            tBgImage: "", //头部的图片
            showTopTit: false, //乐园显示顶部导航栏
            activityId: "", // 正义枪战活动id
            gameId: "101106", // 正义枪战游戏id
            gameInf: null, // 游戏信息
            uuid: "", // 用户uuid
            moduleId: "", // 分享模块id
            btnTxt: "", // 按钮文字
            showMask: false, // 弹窗遮罩
            maskType: 99, // 弹窗类型
            txtTitle: "", // 共用文字弹窗标题
            txtContent: "", // 共用文字弹窗内容
            txtBtn: "", // 共用文字弹窗按钮文字
            status: null, // 下载的状态 1.暂停, 2.成功, 3.失败,
            progress: 0, // 下载进度
            progressWidth: "0%", // 进度条宽度
            isDownload: false, // 是否处于下载游戏过程
            globalStates: null, // 通过分享进入活动时状态管理
            maskLoadingflag: true, //首页进入页面开始的动画(转圆圈)
            shareData: {}, // 分享模块信息
        }
    },
    created() {
        this.activityId = this.$route.query.id;
        /* 活动开启埋点 */
        this.$tea("event_active_show", {activityId: this.activityId});
        if (primaryApi.isSource == "pd") {
            primaryApi.setNativeTitleShow(false); // 隐藏原生顶栏
            //乐园显示顶部导航栏
            this.showTopTit = true;
        }
        /* 获取用户uuid */
        if (primaryApi.isSource == 'sg') {
			this.uuid = JSON.parse(primaryApi.getUserInfo()).uuid;
		} else if (primaryApi.isSource == 'pd') {
			this.uuid = JSON.parse(primaryApi.getUserInfo()).uuId;
        }
        this.entry();
        this.getGamesByIds();
    },
    mounted() {
        /* 状态管理 */
        if (this.$route.query.f) {
            // 通过链接中是否存在分享id，判断是否通过分享进入
            this.globalStates = {
                shareParams: {
                    locationId: parseInt(this.$route.query.f), // 分享功能ID
                    relationship: parseInt(this.$route.query.g), // 分享关系
                    relationshipParams: parseInt(this.$route.query.c), // 分享关系参数
                    parentUUID: this.$route.query.u, // 分享人的UUID
                    scheme: "",
                },
            };
        } else {
            // 非分享进入，分享中转信息写死
            this.globalStates = {
                shareParams: {
                    locationId: 201, // 分享功能ID
                    relationship: 4, // 分享关系
                    relationshipParams: this.activityId, // 分享关系参数
                    parentUUID: "none", // 分享人的UUID
                    scheme: "",
                },
            };
        }
        /* 判断是非233环境下打开页面，有活动模板分享模块就发埋点(这个是定制活动有分享模块) */
        if (!primaryApi.isSource) {
            this.$tea("event_new_share_landing_open", {
                locationId: 201,
                relationship: 4,
                relationshipExtra2: this.activityId,
                parentUUID: this.globalStates.shareParams.parentUUID,
                landingParam: this.activityId
            });
        }
        /* 233乐园内/外部下载进度的回调 */
        window["DownloadProgress"] = (pkg, progress) => {
            if (pkg == this.gameInf.packageName) {
                this.progress = progress;
                const num = this.progress * 100;
                this.btnTxt = num.toFixed(2) + "%";
                this.progressWidth = num.toFixed(2) + "%";
                this.isDownload = true;
            }
        };
        /* 233乐园内/外部下载失败回调 */
        window["DownloadFailed"] = (pkg) => {
            if (pkg == this.gameInf.packageName) {
                this.status = 3;
                this.btnTxt = "继续下载";
                this.$toast("下载失败");
            }
        };
        /* 233乐园内/外部下载暂停回调 */
        window["DownloadInterrupt"] = (pkg) => {
            if (pkg == this.gameInf.packageName) {
                this.status = 1;
			    this.btnTxt = "继续下载";
            }
        };
        /* 233乐园内/外部下载成功回调 */
        window["DownloadSuccess"] = (pkg) => {
            if (pkg == this.gameInf.packageName) {
                this.status = 2;
                this.isDownload = false;
                this.btnTxt = "开始游戏";
                this.progressWidth = "100%";
            }
        };
        //233乐园后退回调
        window["goBackResult"] = (result) => {
            if (result == "failed") {
                //乐园后退失败则关闭界面
                primaryApi.closeActivity();
            }
        };
    },
    methods: {
        // 页面初始化渲染
        entry() {
            active.entry(config.API_HOST + "/apiserv/api/activity/entry",qs.stringify({
                id: this.$route.query.id,
            })).then((res) => {
                this.maskLoadingflag = false;
                if (res.return_code != 200) {
                    this.$toast(res.return_msg);
                    return;
                }
                this.entryObj = res.data;
                this.tBgImage = res.data.activityClient.topImage; // 背景图片
                document.title = res.data.activityClient.productName; // 活动题目
                this.topTitle = res.data.activityClient.productName; //活动标题
                const strArr = res.data.contentShow[0].split("_");
                this.moduleId = strArr[1];
                this.shareInfo();
            }).catch((error) => {
                this.maskLoadingflag = false;
                this.$toast("网络不稳定，请稍后");
            });
        },
        // 获取分享模块信息
        shareInfo() {
            active.shareInfo(config.API_HOST + "/apiserv/api/activity/share/shareInfo", { 
                activityId: this.activityId,
                moduleId: this.moduleId,
                uuid: this.uuid
			}).then((res) => {
                if (res.return_code != 200) {
					this.$toast(res.return_msg);
					return;
                }
                // 1-微信，2-朋友圈，3-QQ，4-QQ空间
                res.data.activityContentShare.btnArr = res.data.activityContentShare.btn.split(';');
                this.shareData = res.data.activityContentShare;
			}).catch((error) => {
				this.$toast("网络不稳定，请稍后");
			});
        },
        // 根据gameId获取游戏信息
		getGamesByIds() {
			active.getGamesByIds(config.API_HOST + "/apiserv/api/repository/game/getGamesByIds", qs.stringify({
				ids: this.gameId
			})).then((res) => {
				if (res.return_code != 200) {
					this.$toast(res.return_msg);
					return;
                }
                this.gameInf = res.data[0].detail;
                this.processInf();
			}).catch((error) => {
				this.$toast("网络不稳定，请稍后");
			});
        },
        // 初始按钮文字显示
        processInf() {
            if (this.gameInf.activeStatus == "OPEN") { // 游戏上线
                if (!primaryApi.isSource) { // 判断运行环境是否是233，非233时逻辑只要到这里即可，否则调用android方法会报错
                    return false;
                }
                if (this.gameInf.installEnvStatus == "VIRTUAL") { //233内部
                    if (primaryApi.isGameInstall(this.gameInf.packageName)) { //内部是否安装了此游戏
                        this.btnTxt = "开始游戏";
                        this.progressWidth = "100%";
                    }
                } else if(this.gameInf.installEnvStatus == 'ANDROID_SYSTEM') { //安卓外部
                    if (primaryApi.isInstallOuterApp(this.gameInf.packageName)) { //外部是否安装了此游戏
                        this.btnTxt = "开始游戏";
                        this.progressWidth = "100%";
                    }
                }
            }
        },
        // 判断运行环境是否233乐园
        correctTerminal() {
            if (primaryApi.isSource == "pd") {
                return true;
            } else {
                this.showMask = true;
                this.maskType = 9;
                return false;
            }
        },
        // 游戏上线，安装游戏和预约
        clickBtn(pos) {
            if (!this.correctTerminal()) { // 判断运行环境是否是233
                return false;
            }
            if (this.isDownload) { // 处于下载游戏过程
                if (this.status == 1 || this.status == 3) {
                    this.$tea("event_active_game_click_temp", {activityId: this.activityId, btnstatus: 13, pos: pos}); // 数据埋点
                    primaryApi.downloadGame(this.gameInf, this.progress) //继续下载游戏
                    this.status = null; //初始状态
                    this.isDownload = true;
                } else { //暂停
                    this.$tea("event_active_game_click_temp", {activityId: this.activityId, btnstatus: 12, pos: pos}); // 数据埋点
                    this.isDownload = true;
                    primaryApi.downloadStop(this.gameInf);
                }
            } else {
                if (this.gameInf.activeStatus == "HIDE") { // 游戏下线
                    this.showMaskTxt("提示", "游戏已下线", "知道了");
                } else if (this.gameInf.activeStatus == "SUBSCRIBED") { // 游戏处于预约状态
                    this.showMaskTxt("提示", "游戏处于预约状态，暂未开放下载", "知道了");
                } else if (this.gameInf.activeStatus == "OPEN") { // 游戏上线
                    if (this.gameInf.installEnvStatus == "VIRTUAL") { //233内部
                        if (primaryApi.isGameInstall(this.gameInf.packageName)) { //内部是否安装了此游戏
                            this.$tea("event_active_game_click_temp", {activityId: this.activityId, btnstatus: 3, pos: pos}); // 数据埋点
                            primaryApi.playGame(this.gameInf); //唤起内部游戏
                        } else {
                            this.$tea("event_active_game_click_temp", {activityId: this.activityId, btnstatus: 11, pos: pos}); // 数据埋点
                            primaryApi.downloadGame(this.gameInf, this.progress); //下载并安装游戏
                        }
                    } else if (this.gameInf.installEnvStatus == 'ANDROID_SYSTEM') { //安卓外部
                        if (primaryApi.isInstallOuterApp(this.gameInf.packageName)) { //外部是否安装了此游戏
                            this.$tea("event_active_game_click_temp", {activityId: this.activityId, btnstatus: 3, pos: pos}); // 数据埋点
                            primaryApi.openOuterAppByPackage(this.gameInf.packageName); //唤起外部游戏
                        } else {
                            this.$tea("event_active_game_click_temp", {activityId: this.activityId, btnstatus: 11, pos: pos}); // 数据埋点
                            primaryApi.downloadGame(this.gameInf, this.progress); //下载并安装游戏
                        }
                    }
                }
            }
        },
        // 点击下载参加活动
        joinTerminal() {
            let ua = navigator.userAgent.toLowerCase();
            this.$tea("event_new_share_landing_click", {
                locationId: 201,
                relationship: 4,
                relationshipExtra2: this.activityId,
                parentUUID: this.globalStates.shareParams.parentUUID,
                landingParam: this.activityId
            });
            if (ua.match(/MicroMessenger/i) == "micromessenger") {
                // 判断是否在微信浏览器打开的
                // 传中转信息
                this.shareSetData();
                window.location.href = "http://a.app.qq.com/o/simple.jsp?pkgname=com.meta.box&android_schema=" + encodeURIComponent(this.getScheme());
            } else {
                // 尝试拉起233app，1.8秒后没拉起则下载app
                window.location.href = this.getScheme(); //通过协议唤起233乐园
                let downloadApk = setTimeout((_) => {
                    window.location.href = "http://cdn.233yang.cn/game/001/233leyuan.apk";
                    // 传中转信息
                    this.shareSetData();
                }, 1800);
                window.addEventListener("visibilitychange", () => {
                    var isHidden = document.hidden;
                    if (isHidden) {
                        clearTimeout(downloadApk);
                    }
                });
            }
            this.showMask = false;
            this.maskType = 99;
        },
        /* 生成 Scheme */
        getScheme(time) {
            time = time || Date.now();
            let url;
            if (config.NODE_ENV === "production") {
                // 正式服
                url = "https://fw.233xyx.com";
            } else if (config.NODE_ENV === "local") {
                // 本地
                url = "http://test2500.fw.233xyx.com";
            } else {
                // 测试，预发
                url = `http://${config.NODE_ENV}.fw.233xyx.com`;
            }
            // f-分享功能ID,g-分享关系,c-分享关系参数,u-分享人的UUID
            const {
                relationshipParams,
                locationId,
                relationship,
                parentUUID,
            } = this.globalStates.shareParams;
            const info = `{"locationId"=${locationId},"relationship"=${relationship},"relationshipParams"=${relationshipParams},"parentUUID"="${parentUUID}"}`;
            const params = `funId=5&acquired=0&clickTime=${time}&info=${info}&url=${url}/active.modal/#/justGunfight?id=${this.activityId}&f=${locationId}&g=${relationship}&c=${relationshipParams}&u=${parentUUID}`;
            return "metaapp://233xyx/web/web?" + params;
        },
        // 传分享的中转信息
        shareSetData() {
            const clickTime = Date.now();
            this.globalStates.shareParams.scheme = this.getScheme(clickTime);
            active.shareSetData(config.API_HOST + "/apiserv/api/share/dataRelay/setData", {
                ipUa: {
                key: "ipUa",
                funId: "5",
                info: this.globalStates.shareParams,
                clickTime: clickTime,
                validitySecond: 86400,
                },
            }).then((res) => {
                if (res.return_code != 200) {
                    this.$toast(res.return_msg);
                    return;
                }
            }).catch((error) => {
                this.$toast("网络不稳定，请稍后");
            });
        },
        // 显示共用文字弹窗
        showMaskTxt(txtTitle, txtContent, txtBtn) {
            this.txtTitle = txtTitle;
            this.txtContent = txtContent;
            this.txtBtn = txtBtn;
            this.showMask = true;
            this.maskType = 3;
        },
        // 图标关闭弹窗
        closeIconMask() {
            this.showMask = false;
            this.maskType = 99;
        },
        // 分享
		shareWeb(shareType) {
            if (!this.correctTerminal()) { // 判断运行环境是否是233
                return false;
            }
            let shareStyle;
            let teaShareType; // 埋点分享类型
            let url;
			switch(shareType) {
				case 0x1:
                    shareStyle = 0x15;
                    teaShareType = 1;
					break;
				case 0x2:
                    shareStyle = 0x16;
                    teaShareType = 2;
					break;
				case 0x3:
                    shareStyle = 0x1f;
                    teaShareType = 3;
					break;
				case 0x4:
                    shareStyle = 0x20;
                    teaShareType = 4;
					break;
            }
            if (config.NODE_ENV === "production") { // 正式服
                url = "http://i.233wei.cn"
            } else if (config.NODE_ENV === "local") { // 本地
                url = "http://test2500.233wei.cn"
            } else { // 测试，预发
                url =  `http://${config.NODE_ENV}.233wei.cn`
            }
			let shareInfo = {
				// 分享网页4个参数
				targetUrl: url + "/active.modal/#/justGunfight?id=" + this.activityId + "&u=" + this.uuid + "&f=201" + "&g=4" + "&c=" + this.activityId, // 分享链接 f-分享功能ID,g-分享关系,c-分享关系参数,u-分享人的UUID
				title: this.shareData.title, // 分享标题
				desc: this.shareData.shareDescribe, // 分享描述
				imgUrl: this.shareData.icon, // 分享图标
				// web
				shareType: shareType, // Int 微信 0x1，微信朋友圈 0x2，QQ 0x3，QQ空间 0x4
				shareStyle: shareStyle, // 落地分享展现方式, 只分享文字 0xB,微信网页 0x15,微信朋友圈分享网页 0x16,qq分享网页 0x1f,qq空间分享网页 0x20
                isWeb: true, // 是否由web端创建对话框
                locationId: 301, // Int 功能ID
				relationship: 4, // Int 关系（3:游戏分享）
				relationshipExtra: this.activityId, // Long关系参数（3：gameId） string
				pos: 2001, // Int APP进入位置
				posExtra: this.activityId // Long APP进入位置参数
            };
            this.$tea("event_new_share_click", {activityId: this.activityId, modul: -1, locationId: 201, relationship: 4, relationshipExtra2: this.activityId, pos: 2001, shareType: teaShareType});
			primaryApi.share(shareInfo) // 调用安卓api分享
        },
        //刷新
        refreshClick() {
            this.reload();
        },
        //后退
        goBack() {
            if (primaryApi.isSource == "pd") {
                //乐园环境
                primaryApi.goBack();
            }
        },
    }
}
</script>
<style scoped>
    .maskLoading {
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        z-index: 999;
        background: rgba(189, 84, 28, 0.98);
        display: flex;
        justify-content: space-around;
        align-items: center;
    }
    .maskLoading img {
        display: block;
        width: 0.4rem;
        height: 0.4rem;
        animation: loading 2s linear 0s infinite;
    }
    @keyframes loading {
        from {
            transform: rotate(0);
        }

        to {
            transform: rotate(360deg);
        }
    }
    .topTit {
        width: 100%;
        height: 0.46rem;
        line-height: 0.46rem;
        background-color: #fff;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 998;
        display: flex;
        justify-content: left;
        align-items: center;
        padding: 0 0.05rem;
    }
    .refresh {
        /* position: absolute; */
        /* right: 0.05rem; */
        /* top: 0; */
        height: 100%;
        width: 0.4rem;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
        font-size: 0;
    }
    .refresh img {
        width: 22.8px;
        height: 30.6px;
    }
    .refresh span {
        color: #515151;
        font-size: 0.06rem;
        line-height: 0.2rem;
        /* transform: scale(0.9, 0.9); */
        margin-top: -0.1rem;
    }
    .van-notice-bar {
        width: 100%;
        text-align: center;
        font-size: 0.16rem;
        padding: 0 0.1rem;
    }
    .navText >>> .van-notice-bar__content {
        text-align: center;
        min-width: 100%;
    }
    .pdTop {
        padding-top: 0.46rem;
    }
    .justBox {
        position: relative;
    }
    .justBox .bg {
        width: 100%;
        height: auto;
    }
    .justBox .btn {
        position: absolute;
        z-index: 1;
        left: 50%;
        -webkit-transform: translateX(-50%);
        transform: translateX(-50%);
         bottom: 15px;
    }
    .justBox .btn img {
        width: 110px;
        height: auto;
    }
    .head .btn {
        width: 163px;
        height: 46px;
        background: linear-gradient(0deg, #AF0000, #5E0800);
        border: 3px solid #730401;
        border-radius: 12px;
        bottom: 36px;
        overflow: hidden;
    }
    .progress {
        height: 100%;
        background: linear-gradient(0deg, #E61717, #930606);
    }
    .btnTxt {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        color: #fff;
        font-size: 16px;
        display: flex;
		justify-content: center;
        align-items: center;
        font-weight: bold;
    }
    .head .btnTxt {
        font-size: 20px;
    }
    .justBox .btn .downloadIcon {
        position: absolute;
        left: 10px;
        width: 14.7px;
        height: 18.9px;
    }
    .twoMain .btn {
        bottom: 16px;
    }
    .shareBtn {
        text-align: center;
        width: 100%;
        position: absolute;
        bottom: 25px;
    }
    .iconItem {
        text-align: center;
        margin-right: 20px;
        display: inline-block;
    }
    .iconItem:last-child {
        margin-right: 0;
    }
    .iconItem img {
        width: 58px;
        height: 58px;
    }
    .iconItem p {
        margin: 5px 0 0;
        padding-left: 0;
        color: #fff;
    }
    .mask {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.75);
        z-index: 151;
    }
    .maskBox {
        width: 320px;
        height: auto;
        background-color: #fff;
        border-radius: 0.12rem;
        padding: 15px 20px 20px;
        position: absolute;
        top: 50%;
        left: 50%;
        -webkit-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        /* overflow: hidden; */
    }
    .closeMask {
        text-align: right;
        font-size: 0;
        position: relative;
        z-index: 152;
    }
    .closeMask img {
        width: 14px;
        height: 14px;
    }
    .tit {
        text-align: center;
        font-weight: bold;
        font-size: 18px;
    }
    .toastMask p {
        font-size: 14px;
        text-align: center;
        color: #666;
        margin-top: 12px;
    }
    .toastBtn {
        width: 100%;
        height: 46px;
        line-height: 46px;
        border-radius: 23px;
        background-color: #ff9500;
        text-align: center;
        color: #fff;
        font-size: 17px;
        margin-top: 12px;
    }
    .phonBox {
        padding-bottom: 10px;
    }
    .phonBox .tit {
        margin-bottom: 10px;
    }
    .terminalTips {
        padding-bottom: 15px;
    }
    .terminalTips p {
        color: #666666;
    }
    .phoneBtn {
        font-size: 0.15rem;
        color: #ff9500;
        border: none;
        border-top: 1px solid #eeeeee !important;
        width: 100%;
        text-align: center;
        padding: 0.12rem 0;
    }
    .padbottom {
        padding-bottom: 0;
    }
</style>